import { connect } from 'react-redux';
import * as examSelectors from 'edrolo/domains/exams/data/selectors';
import QuestionSetPage from './QuestionSetPage';
import { getProfile, profileUtils } from 'edrolo/domains/profile';
import {
  loadExam,
  ensureSittingLoaded,
  submitChecklistReflectionItem,
  submitQuestionGrok,
  submitQuestionMark,
  submitQuestionResponse,
} from 'edrolo/domains/exams/data/actions';
import {
  getRootQuestionDescendants,
  getPrevNextQuestionIds,
  filterQuestions,
} from '../../utils';
import { OrderedMap } from 'immutable';

const mapStateToProps = (
  state,
  { examId, classId, questionId, searchParams }
) => {
  const profile = getProfile(state);
  const isTeacher = profileUtils.isOverseerOfClass(profile, classId);
  const flatQuestionsUnfiltered = examSelectors.getFlatQuestions(state, examId);
  const flatQuestions = filterQuestions(flatQuestionsUnfiltered, searchParams);

  const filterToggle = {
    hasSpiciness: !!flatQuestionsUnfiltered?.some((q) =>
      q.get('spiciness_level')
    ),
    hasWorkingPaths: !!flatQuestionsUnfiltered?.some(
      (q) => q.get('working_pathways').size > 0
    ),
  };

  const rootQuestionDescendants = getRootQuestionDescendants(
    flatQuestions,
    questionId
  );

  let parentQuestions = OrderedMap();

  flatQuestions?.forEach((item) => {
    const children = getRootQuestionDescendants(flatQuestions, item.get('id'));
    const parent = children.first();

    if (!parentQuestions.has(parent.get('id'))) {
      parentQuestions = parentQuestions.set(parent.get('id'), parent);
    }
  });

  const question = flatQuestions?.get(questionId);
  const firstChildId = rootQuestionDescendants?.first().get('id');

  const prevNextParentQuestionIds = getPrevNextQuestionIds(
    parentQuestions,
    firstChildId
  );

  const prevNextQuestionIds = getPrevNextQuestionIds(flatQuestions, questionId);

  const sitting = examSelectors.getSitting(state, examId);

  const prevNextIds = {
    prevParentId: prevNextParentQuestionIds.prevId,
    nextParentId: prevNextParentQuestionIds.nextId,
    prevId: prevNextQuestionIds.prevId,
    nextId: prevNextQuestionIds.nextId,
  };

  return {
    exam: examSelectors.getExam(state, examId),
    examStatus: examSelectors.getExamLoadingStatus(state, examId),
    examError: examSelectors.getExamLoadError(state, examId),
    sittingId: sitting?.get('id'),
    loadingText: state.exams.get('loadingText'),
    sections: examSelectors.getSections(state, examId),
    numQuestions: flatQuestions?.size || 0,
    questionsBySectionId: examSelectors.getFlatQuestionsIndexedBySectionId(
      state,
      examId
    ),
    getQuestionInstructionText: (questionId) =>
      examSelectors.getSensibleInstructionTextForQuestionId(state, questionId),
    questionResponses: examSelectors.getResponses(state, examId),
    question,
    response: examSelectors.getResponse(state, questionId),
    prevNextIds,
    rootQuestionDescendants,
    isTeacher,
    grokkingItemIsSaving: examSelectors.getGrokkingItemIsSaving(
      state,
      questionId
    ),
    checklistItemIsSaving: examSelectors.getChecklistItemIsSaving(
      state,
      questionId
    ),
    searchParams,
    filterToggle,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadExam: (examId) => dispatch(loadExam.signal(examId)),
  ensureSittingLoaded: (examId) => dispatch(ensureSittingLoaded.signal(examId)),
  submitQuestionResponse: (examId, questionId, sittingId, typeSpecificData) =>
    dispatch(
      submitQuestionResponse.signal(
        examId,
        questionId,
        sittingId,
        typeSpecificData
      )
    ),
  submitChecklistReflectionItem: (
    questionId,
    sittingId,
    checklistReflectionItem
  ) =>
    dispatch(
      submitChecklistReflectionItem.signal(
        questionId,
        sittingId,
        checklistReflectionItem
      )
    ),
  submitGrok: (examId, questionId, sittingId, grokked) => {
    dispatch(submitQuestionGrok.signal(examId, questionId, sittingId, grokked));
  },
  submitMark: (questionId, sittingId, mark) => {
    dispatch(submitQuestionMark.signal(questionId, sittingId, mark));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionSetPage);
